module.exports = __webpack_public_path__ + "static/we-handle-your-operation-5f42d159d469f4595b1a78a21b2071b2.svg";